import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

const post = (path, payload = {}, authHeaders = {}) =>
  apiCallPost(path, payload, authHeaders);

export const initiatePaymentApi = (payload, authHeaders) =>
  post(apiPaths.initiatePayment, payload, authHeaders);

export const listPlansApi = (payload, authHeaders) =>
  post(apiPaths.listPlans, payload, authHeaders);

export const getBillingDetailsApi = (payload, authHeaders) =>
  post(apiPaths.getBillingDetails, payload, authHeaders);

export const subscriptionApi = (payload, authHeaders) =>
  post(apiPaths.subscription, payload, authHeaders);

export const subscriptionStatusApi = (payload, authHeaders) =>
  post(apiPaths.subscriptionStatus, payload, authHeaders);